/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */
import { faker } from "@faker-js/faker"
import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"
import type {
	MarketingReportFieldsResponse,
	MarketingTask,
	MarketingTaskListItem,
	MarketingTaskListResponse,
	RunMarketingTaskNowResponse,
} from ".././types/marketing"
import {
	MarketingAudienceRulesMatch,
	MarketingReportFieldKey,
	MarketingRunStatus,
	MarketingTaskStatus,
	MarketingTaskType,
	UpcomingAppointmentExclusionScope,
} from ".././types/marketing"

export const getListMarketingTasksResponseMock = (
	overrideResponse: Partial<Extract<MarketingTaskListResponse, object>> = {},
): MarketingTaskListResponse => ({
	data: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		type: faker.helpers.arrayElement(Object.values(MarketingTaskType)),
		name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		description: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			undefined,
		]),
		status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
		active: faker.datatype.boolean(),
		scheduleKind: faker.helpers.arrayElement(["once", "recurring"] as const),
		scheduleLabel: "По расписанию",
		whenLabel: "Каждый день в 10:00",
		statusLabel: "Сегодня в 10:00",
		statusSubLabel: "был 28.05.2026 10:02",
		nextRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
		lastRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
	})),
	paging: {
		page: faker.number.int(),
		pageSize: faker.number.int(),
		total: faker.number.int(),
	},
	...overrideResponse,
})

export const getCreateMarketingTaskResponseMock = (): MarketingTask => ({
	...{
		type: faker.helpers.arrayElement(Object.values(MarketingTaskType)),
		name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		description: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			undefined,
		]),
		active: faker.datatype.boolean(),
		status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
		schedule: {
			mode: faker.helpers.arrayElement(["once", "recurring"] as const),
			once: faker.helpers.arrayElement([
				{
					at: faker.helpers.arrayElement([
						faker.date.past().toISOString().slice(0, 19) + "Z",
						undefined,
					]),
				},
				undefined,
			]),
			recurring: faker.helpers.arrayElement([
				{
					frequency: faker.helpers.arrayElement([
						faker.helpers.arrayElement(["day", "week", "month"] as const),
						undefined,
					]),
					time: "10:00",
					weekday: faker.helpers.arrayElement([
						faker.number.int({ min: 0, max: 6 }),
						undefined,
					]),
					monthDay: faker.helpers.arrayElement([
						faker.number.int({ min: 1, max: 31 }),
						undefined,
					]),
				},
				undefined,
			]),
			validity: {
				kind: faker.helpers.arrayElement([
					"forever",
					"from",
					"interval",
				] as const),
				from: faker.helpers.arrayElement([
					faker.date.past().toISOString().slice(0, 19) + "Z",
					undefined,
				]),
				to: faker.helpers.arrayElement([
					faker.date.past().toISOString().slice(0, 19) + "Z",
					undefined,
				]),
			},
			timezone: "Europe/Moscow",
		},
		audience: {
			rules: Array.from(
				{ length: faker.number.int({ min: 1, max: 5 }) },
				(_, i) => i + 1,
			).map(() => ({
				name: "client_birthday",
				operator: "birthday_eq",
				value: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					faker.number.float({ fractionDigits: 2 }),
					faker.datatype.boolean(),
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({})),
				]),
			})),
			rulesMatch: faker.helpers.arrayElement([
				faker.helpers.arrayElement(Object.values(MarketingAudienceRulesMatch)),
				undefined,
			]),
			savedSegmentId: faker.helpers.arrayElement([
				faker.string.alpha({ length: { min: 10, max: 20 } }),
				undefined,
			]),
		},
		exclusion: faker.helpers.arrayElement([
			{
				enabled: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				noRepeat: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				windowDays: faker.helpers.arrayElement([
					faker.number.int({ min: 1, max: 365 }),
					undefined,
				]),
				skipUpcomingAppointment: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				upcomingAppointmentScope: faker.helpers.arrayElement([
					faker.helpers.arrayElement(
						Object.values(UpcomingAppointmentExclusionScope),
					),
					undefined,
				]),
				upcomingSpecializationIds: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
					undefined,
				]),
				upcomingResourceIds: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
					undefined,
				]),
				rules: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({
						name: "client_birthday",
						operator: "birthday_eq",
						value: faker.helpers.arrayElement([
							faker.string.alpha({ length: { min: 10, max: 20 } }),
							faker.number.float({ fractionDigits: 2 }),
							faker.datatype.boolean(),
							Array.from(
								{ length: faker.number.int({ min: 1, max: 5 }) },
								(_, i) => i + 1,
							).map(() => ({})),
						]),
					})),
					undefined,
				]),
			},
			undefined,
		]),
		message: faker.helpers.arrayElement([
			{
				text: faker.string.alpha({ length: { min: 10, max: 20 } }),
				channels: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({
						type: faker.helpers.arrayElement([
							"whatsapp",
							"telegram",
							"max",
							"sms",
							"viber",
							"messengers",
						] as const),
						order: faker.number.int({ min: 1 }),
						enabled: faker.datatype.boolean(),
					})),
					undefined,
				]),
				priority: faker.helpers.arrayElement([
					faker.helpers.arrayElement(["low", "medium", "high"] as const),
					undefined,
				]),
				senderBusinessId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				smsIntegrationId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				smsChannel: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				mediaId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					null,
				]),
				mediaUrl: faker.helpers.arrayElement([faker.internet.url(), null]),
			},
			undefined,
		]),
		report: faker.helpers.arrayElement([
			{
				fields: Array.from(
					{ length: faker.number.int({ min: 1, max: 5 }) },
					(_, i) => i + 1,
				).map(() => ({
					key: faker.helpers.arrayElement(
						Object.values(MarketingReportFieldKey),
					),
					order: faker.number.int({ min: 1 }),
				})),
				email: faker.helpers.arrayElement([
					{
						enabled: faker.datatype.boolean(),
						recipient: faker.helpers.arrayElement([
							faker.internet.email(),
							undefined,
						]),
						archivePassword: faker.helpers.arrayElement([
							faker.string.alpha({ length: { min: 10, max: 20 } }),
							undefined,
						]),
					},
					undefined,
				]),
			},
			undefined,
		]),
	},
	...{
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
		scheduleLabel: "Каждый день в 10:00",
		nextRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
		lastRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
		lastRunStatus: faker.helpers.arrayElement([
			faker.helpers.arrayElement(Object.values(MarketingRunStatus)),
			null,
		]),
		createdAt: faker.date.past().toISOString().slice(0, 19) + "Z",
		updatedAt: faker.date.past().toISOString().slice(0, 19) + "Z",
	},
})

export const getGetMarketingTaskResponseMock = (): MarketingTask => ({
	...{
		type: faker.helpers.arrayElement(Object.values(MarketingTaskType)),
		name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		description: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			undefined,
		]),
		active: faker.datatype.boolean(),
		status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
		schedule: {
			mode: faker.helpers.arrayElement(["once", "recurring"] as const),
			once: faker.helpers.arrayElement([
				{
					at: faker.helpers.arrayElement([
						faker.date.past().toISOString().slice(0, 19) + "Z",
						undefined,
					]),
				},
				undefined,
			]),
			recurring: faker.helpers.arrayElement([
				{
					frequency: faker.helpers.arrayElement([
						faker.helpers.arrayElement(["day", "week", "month"] as const),
						undefined,
					]),
					time: "10:00",
					weekday: faker.helpers.arrayElement([
						faker.number.int({ min: 0, max: 6 }),
						undefined,
					]),
					monthDay: faker.helpers.arrayElement([
						faker.number.int({ min: 1, max: 31 }),
						undefined,
					]),
				},
				undefined,
			]),
			validity: {
				kind: faker.helpers.arrayElement([
					"forever",
					"from",
					"interval",
				] as const),
				from: faker.helpers.arrayElement([
					faker.date.past().toISOString().slice(0, 19) + "Z",
					undefined,
				]),
				to: faker.helpers.arrayElement([
					faker.date.past().toISOString().slice(0, 19) + "Z",
					undefined,
				]),
			},
			timezone: "Europe/Moscow",
		},
		audience: {
			rules: Array.from(
				{ length: faker.number.int({ min: 1, max: 5 }) },
				(_, i) => i + 1,
			).map(() => ({
				name: "client_birthday",
				operator: "birthday_eq",
				value: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					faker.number.float({ fractionDigits: 2 }),
					faker.datatype.boolean(),
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({})),
				]),
			})),
			rulesMatch: faker.helpers.arrayElement([
				faker.helpers.arrayElement(Object.values(MarketingAudienceRulesMatch)),
				undefined,
			]),
			savedSegmentId: faker.helpers.arrayElement([
				faker.string.alpha({ length: { min: 10, max: 20 } }),
				undefined,
			]),
		},
		exclusion: faker.helpers.arrayElement([
			{
				enabled: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				noRepeat: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				windowDays: faker.helpers.arrayElement([
					faker.number.int({ min: 1, max: 365 }),
					undefined,
				]),
				skipUpcomingAppointment: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				upcomingAppointmentScope: faker.helpers.arrayElement([
					faker.helpers.arrayElement(
						Object.values(UpcomingAppointmentExclusionScope),
					),
					undefined,
				]),
				upcomingSpecializationIds: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
					undefined,
				]),
				upcomingResourceIds: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
					undefined,
				]),
				rules: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({
						name: "client_birthday",
						operator: "birthday_eq",
						value: faker.helpers.arrayElement([
							faker.string.alpha({ length: { min: 10, max: 20 } }),
							faker.number.float({ fractionDigits: 2 }),
							faker.datatype.boolean(),
							Array.from(
								{ length: faker.number.int({ min: 1, max: 5 }) },
								(_, i) => i + 1,
							).map(() => ({})),
						]),
					})),
					undefined,
				]),
			},
			undefined,
		]),
		message: faker.helpers.arrayElement([
			{
				text: faker.string.alpha({ length: { min: 10, max: 20 } }),
				channels: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({
						type: faker.helpers.arrayElement([
							"whatsapp",
							"telegram",
							"max",
							"sms",
							"viber",
							"messengers",
						] as const),
						order: faker.number.int({ min: 1 }),
						enabled: faker.datatype.boolean(),
					})),
					undefined,
				]),
				priority: faker.helpers.arrayElement([
					faker.helpers.arrayElement(["low", "medium", "high"] as const),
					undefined,
				]),
				senderBusinessId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				smsIntegrationId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				smsChannel: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				mediaId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					null,
				]),
				mediaUrl: faker.helpers.arrayElement([faker.internet.url(), null]),
			},
			undefined,
		]),
		report: faker.helpers.arrayElement([
			{
				fields: Array.from(
					{ length: faker.number.int({ min: 1, max: 5 }) },
					(_, i) => i + 1,
				).map(() => ({
					key: faker.helpers.arrayElement(
						Object.values(MarketingReportFieldKey),
					),
					order: faker.number.int({ min: 1 }),
				})),
				email: faker.helpers.arrayElement([
					{
						enabled: faker.datatype.boolean(),
						recipient: faker.helpers.arrayElement([
							faker.internet.email(),
							undefined,
						]),
						archivePassword: faker.helpers.arrayElement([
							faker.string.alpha({ length: { min: 10, max: 20 } }),
							undefined,
						]),
					},
					undefined,
				]),
			},
			undefined,
		]),
	},
	...{
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
		scheduleLabel: "Каждый день в 10:00",
		nextRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
		lastRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
		lastRunStatus: faker.helpers.arrayElement([
			faker.helpers.arrayElement(Object.values(MarketingRunStatus)),
			null,
		]),
		createdAt: faker.date.past().toISOString().slice(0, 19) + "Z",
		updatedAt: faker.date.past().toISOString().slice(0, 19) + "Z",
	},
})

export const getUpdateMarketingTaskResponseMock = (): MarketingTask => ({
	...{
		type: faker.helpers.arrayElement(Object.values(MarketingTaskType)),
		name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		description: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			undefined,
		]),
		active: faker.datatype.boolean(),
		status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
		schedule: {
			mode: faker.helpers.arrayElement(["once", "recurring"] as const),
			once: faker.helpers.arrayElement([
				{
					at: faker.helpers.arrayElement([
						faker.date.past().toISOString().slice(0, 19) + "Z",
						undefined,
					]),
				},
				undefined,
			]),
			recurring: faker.helpers.arrayElement([
				{
					frequency: faker.helpers.arrayElement([
						faker.helpers.arrayElement(["day", "week", "month"] as const),
						undefined,
					]),
					time: "10:00",
					weekday: faker.helpers.arrayElement([
						faker.number.int({ min: 0, max: 6 }),
						undefined,
					]),
					monthDay: faker.helpers.arrayElement([
						faker.number.int({ min: 1, max: 31 }),
						undefined,
					]),
				},
				undefined,
			]),
			validity: {
				kind: faker.helpers.arrayElement([
					"forever",
					"from",
					"interval",
				] as const),
				from: faker.helpers.arrayElement([
					faker.date.past().toISOString().slice(0, 19) + "Z",
					undefined,
				]),
				to: faker.helpers.arrayElement([
					faker.date.past().toISOString().slice(0, 19) + "Z",
					undefined,
				]),
			},
			timezone: "Europe/Moscow",
		},
		audience: {
			rules: Array.from(
				{ length: faker.number.int({ min: 1, max: 5 }) },
				(_, i) => i + 1,
			).map(() => ({
				name: "client_birthday",
				operator: "birthday_eq",
				value: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					faker.number.float({ fractionDigits: 2 }),
					faker.datatype.boolean(),
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({})),
				]),
			})),
			rulesMatch: faker.helpers.arrayElement([
				faker.helpers.arrayElement(Object.values(MarketingAudienceRulesMatch)),
				undefined,
			]),
			savedSegmentId: faker.helpers.arrayElement([
				faker.string.alpha({ length: { min: 10, max: 20 } }),
				undefined,
			]),
		},
		exclusion: faker.helpers.arrayElement([
			{
				enabled: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				noRepeat: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				windowDays: faker.helpers.arrayElement([
					faker.number.int({ min: 1, max: 365 }),
					undefined,
				]),
				skipUpcomingAppointment: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				upcomingAppointmentScope: faker.helpers.arrayElement([
					faker.helpers.arrayElement(
						Object.values(UpcomingAppointmentExclusionScope),
					),
					undefined,
				]),
				upcomingSpecializationIds: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
					undefined,
				]),
				upcomingResourceIds: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
					undefined,
				]),
				rules: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({
						name: "client_birthday",
						operator: "birthday_eq",
						value: faker.helpers.arrayElement([
							faker.string.alpha({ length: { min: 10, max: 20 } }),
							faker.number.float({ fractionDigits: 2 }),
							faker.datatype.boolean(),
							Array.from(
								{ length: faker.number.int({ min: 1, max: 5 }) },
								(_, i) => i + 1,
							).map(() => ({})),
						]),
					})),
					undefined,
				]),
			},
			undefined,
		]),
		message: faker.helpers.arrayElement([
			{
				text: faker.string.alpha({ length: { min: 10, max: 20 } }),
				channels: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({
						type: faker.helpers.arrayElement([
							"whatsapp",
							"telegram",
							"max",
							"sms",
							"viber",
							"messengers",
						] as const),
						order: faker.number.int({ min: 1 }),
						enabled: faker.datatype.boolean(),
					})),
					undefined,
				]),
				priority: faker.helpers.arrayElement([
					faker.helpers.arrayElement(["low", "medium", "high"] as const),
					undefined,
				]),
				senderBusinessId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				smsIntegrationId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				smsChannel: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				mediaId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					null,
				]),
				mediaUrl: faker.helpers.arrayElement([faker.internet.url(), null]),
			},
			undefined,
		]),
		report: faker.helpers.arrayElement([
			{
				fields: Array.from(
					{ length: faker.number.int({ min: 1, max: 5 }) },
					(_, i) => i + 1,
				).map(() => ({
					key: faker.helpers.arrayElement(
						Object.values(MarketingReportFieldKey),
					),
					order: faker.number.int({ min: 1 }),
				})),
				email: faker.helpers.arrayElement([
					{
						enabled: faker.datatype.boolean(),
						recipient: faker.helpers.arrayElement([
							faker.internet.email(),
							undefined,
						]),
						archivePassword: faker.helpers.arrayElement([
							faker.string.alpha({ length: { min: 10, max: 20 } }),
							undefined,
						]),
					},
					undefined,
				]),
			},
			undefined,
		]),
	},
	...{
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
		scheduleLabel: "Каждый день в 10:00",
		nextRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
		lastRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
		lastRunStatus: faker.helpers.arrayElement([
			faker.helpers.arrayElement(Object.values(MarketingRunStatus)),
			null,
		]),
		createdAt: faker.date.past().toISOString().slice(0, 19) + "Z",
		updatedAt: faker.date.past().toISOString().slice(0, 19) + "Z",
	},
})

export const getToggleMarketingTaskResponseMock = (
	overrideResponse: Partial<Extract<MarketingTaskListItem, object>> = {},
): MarketingTaskListItem => ({
	id: faker.string.alpha({ length: { min: 10, max: 20 } }),
	type: faker.helpers.arrayElement(Object.values(MarketingTaskType)),
	name: faker.string.alpha({ length: { min: 10, max: 20 } }),
	description: faker.helpers.arrayElement([
		faker.string.alpha({ length: { min: 10, max: 20 } }),
		undefined,
	]),
	status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
	active: faker.datatype.boolean(),
	scheduleKind: faker.helpers.arrayElement(["once", "recurring"] as const),
	scheduleLabel: "По расписанию",
	whenLabel: "Каждый день в 10:00",
	statusLabel: "Сегодня в 10:00",
	statusSubLabel: "был 28.05.2026 10:02",
	nextRunAt: faker.helpers.arrayElement([
		faker.date.past().toISOString().slice(0, 19) + "Z",
		null,
	]),
	lastRunAt: faker.helpers.arrayElement([
		faker.date.past().toISOString().slice(0, 19) + "Z",
		null,
	]),
	...overrideResponse,
})

export const getDuplicateMarketingTaskResponseMock = (): MarketingTask => ({
	...{
		type: faker.helpers.arrayElement(Object.values(MarketingTaskType)),
		name: faker.string.alpha({ length: { min: 10, max: 20 } }),
		description: faker.helpers.arrayElement([
			faker.string.alpha({ length: { min: 10, max: 20 } }),
			undefined,
		]),
		active: faker.datatype.boolean(),
		status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
		schedule: {
			mode: faker.helpers.arrayElement(["once", "recurring"] as const),
			once: faker.helpers.arrayElement([
				{
					at: faker.helpers.arrayElement([
						faker.date.past().toISOString().slice(0, 19) + "Z",
						undefined,
					]),
				},
				undefined,
			]),
			recurring: faker.helpers.arrayElement([
				{
					frequency: faker.helpers.arrayElement([
						faker.helpers.arrayElement(["day", "week", "month"] as const),
						undefined,
					]),
					time: "10:00",
					weekday: faker.helpers.arrayElement([
						faker.number.int({ min: 0, max: 6 }),
						undefined,
					]),
					monthDay: faker.helpers.arrayElement([
						faker.number.int({ min: 1, max: 31 }),
						undefined,
					]),
				},
				undefined,
			]),
			validity: {
				kind: faker.helpers.arrayElement([
					"forever",
					"from",
					"interval",
				] as const),
				from: faker.helpers.arrayElement([
					faker.date.past().toISOString().slice(0, 19) + "Z",
					undefined,
				]),
				to: faker.helpers.arrayElement([
					faker.date.past().toISOString().slice(0, 19) + "Z",
					undefined,
				]),
			},
			timezone: "Europe/Moscow",
		},
		audience: {
			rules: Array.from(
				{ length: faker.number.int({ min: 1, max: 5 }) },
				(_, i) => i + 1,
			).map(() => ({
				name: "client_birthday",
				operator: "birthday_eq",
				value: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					faker.number.float({ fractionDigits: 2 }),
					faker.datatype.boolean(),
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({})),
				]),
			})),
			rulesMatch: faker.helpers.arrayElement([
				faker.helpers.arrayElement(Object.values(MarketingAudienceRulesMatch)),
				undefined,
			]),
			savedSegmentId: faker.helpers.arrayElement([
				faker.string.alpha({ length: { min: 10, max: 20 } }),
				undefined,
			]),
		},
		exclusion: faker.helpers.arrayElement([
			{
				enabled: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				noRepeat: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				windowDays: faker.helpers.arrayElement([
					faker.number.int({ min: 1, max: 365 }),
					undefined,
				]),
				skipUpcomingAppointment: faker.helpers.arrayElement([
					faker.datatype.boolean(),
					undefined,
				]),
				upcomingAppointmentScope: faker.helpers.arrayElement([
					faker.helpers.arrayElement(
						Object.values(UpcomingAppointmentExclusionScope),
					),
					undefined,
				]),
				upcomingSpecializationIds: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
					undefined,
				]),
				upcomingResourceIds: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => faker.string.alpha({ length: { min: 10, max: 20 } })),
					undefined,
				]),
				rules: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({
						name: "client_birthday",
						operator: "birthday_eq",
						value: faker.helpers.arrayElement([
							faker.string.alpha({ length: { min: 10, max: 20 } }),
							faker.number.float({ fractionDigits: 2 }),
							faker.datatype.boolean(),
							Array.from(
								{ length: faker.number.int({ min: 1, max: 5 }) },
								(_, i) => i + 1,
							).map(() => ({})),
						]),
					})),
					undefined,
				]),
			},
			undefined,
		]),
		message: faker.helpers.arrayElement([
			{
				text: faker.string.alpha({ length: { min: 10, max: 20 } }),
				channels: faker.helpers.arrayElement([
					Array.from(
						{ length: faker.number.int({ min: 1, max: 5 }) },
						(_, i) => i + 1,
					).map(() => ({
						type: faker.helpers.arrayElement([
							"whatsapp",
							"telegram",
							"max",
							"sms",
							"viber",
							"messengers",
						] as const),
						order: faker.number.int({ min: 1 }),
						enabled: faker.datatype.boolean(),
					})),
					undefined,
				]),
				priority: faker.helpers.arrayElement([
					faker.helpers.arrayElement(["low", "medium", "high"] as const),
					undefined,
				]),
				senderBusinessId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				smsIntegrationId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				smsChannel: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					undefined,
				]),
				mediaId: faker.helpers.arrayElement([
					faker.string.alpha({ length: { min: 10, max: 20 } }),
					null,
				]),
				mediaUrl: faker.helpers.arrayElement([faker.internet.url(), null]),
			},
			undefined,
		]),
		report: faker.helpers.arrayElement([
			{
				fields: Array.from(
					{ length: faker.number.int({ min: 1, max: 5 }) },
					(_, i) => i + 1,
				).map(() => ({
					key: faker.helpers.arrayElement(
						Object.values(MarketingReportFieldKey),
					),
					order: faker.number.int({ min: 1 }),
				})),
				email: faker.helpers.arrayElement([
					{
						enabled: faker.datatype.boolean(),
						recipient: faker.helpers.arrayElement([
							faker.internet.email(),
							undefined,
						]),
						archivePassword: faker.helpers.arrayElement([
							faker.string.alpha({ length: { min: 10, max: 20 } }),
							undefined,
						]),
					},
					undefined,
				]),
			},
			undefined,
		]),
	},
	...{
		id: faker.string.alpha({ length: { min: 10, max: 20 } }),
		status: faker.helpers.arrayElement(Object.values(MarketingTaskStatus)),
		scheduleLabel: "Каждый день в 10:00",
		nextRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
		lastRunAt: faker.helpers.arrayElement([
			faker.date.past().toISOString().slice(0, 19) + "Z",
			null,
		]),
		lastRunStatus: faker.helpers.arrayElement([
			faker.helpers.arrayElement(Object.values(MarketingRunStatus)),
			null,
		]),
		createdAt: faker.date.past().toISOString().slice(0, 19) + "Z",
		updatedAt: faker.date.past().toISOString().slice(0, 19) + "Z",
	},
})

export const getRunMarketingTaskNowResponseMock = (
	overrideResponse: Partial<Extract<RunMarketingTaskNowResponse, object>> = {},
): RunMarketingTaskNowResponse => ({
	runId: faker.string.alpha({ length: { min: 10, max: 20 } }),
	status: faker.helpers.arrayElement(["queued", "running"] as const),
	...overrideResponse,
})

export const getGetMarketingReportFieldsResponseMock = (
	overrideResponse: Partial<
		Extract<MarketingReportFieldsResponse, object>
	> = {},
): MarketingReportFieldsResponse => ({
	fields: Array.from(
		{ length: faker.number.int({ min: 1, max: 5 }) },
		(_, i) => i + 1,
	).map(() => ({
		key: faker.helpers.arrayElement(Object.values(MarketingReportFieldKey)),
		label: faker.string.alpha({ length: { min: 10, max: 20 } }),
	})),
	...overrideResponse,
})

export const getListMarketingTasksMockHandler = (
	overrideResponse?:
		| MarketingTaskListResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<MarketingTaskListResponse> | MarketingTaskListResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/tasks",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getListMarketingTasksResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getCreateMarketingTaskMockHandler = (
	overrideResponse?:
		| MarketingTask
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<MarketingTask> | MarketingTask),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/tasks",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getCreateMarketingTaskResponseMock(),
				{ status: 201 },
			)
		},
		options,
	)
}

export const getGetMarketingTaskMockHandler = (
	overrideResponse?:
		| MarketingTask
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<MarketingTask> | MarketingTask),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/tasks/:taskId",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetMarketingTaskResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getUpdateMarketingTaskMockHandler = (
	overrideResponse?:
		| MarketingTask
		| ((
				info: Parameters<Parameters<typeof http.put>[1]>[0],
		  ) => Promise<MarketingTask> | MarketingTask),
	options?: RequestHandlerOptions,
) => {
	return http.put(
		"*/marketing/tasks/:taskId",
		async (info: Parameters<Parameters<typeof http.put>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getUpdateMarketingTaskResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getDeleteMarketingTaskMockHandler = (
	overrideResponse?:
		| void
		| ((
				info: Parameters<Parameters<typeof http.delete>[1]>[0],
		  ) => Promise<void> | void),
	options?: RequestHandlerOptions,
) => {
	return http.delete(
		"*/marketing/tasks/:taskId",
		async (info: Parameters<Parameters<typeof http.delete>[1]>[0]) => {
			await delay(300)
			if (typeof overrideResponse === "function") {
				await overrideResponse(info)
			}

			return new HttpResponse(null, { status: 204 })
		},
		options,
	)
}

export const getToggleMarketingTaskMockHandler = (
	overrideResponse?:
		| MarketingTaskListItem
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<MarketingTaskListItem> | MarketingTaskListItem),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/tasks/:taskId/toggle",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getToggleMarketingTaskResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getDuplicateMarketingTaskMockHandler = (
	overrideResponse?:
		| MarketingTask
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<MarketingTask> | MarketingTask),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/tasks/:taskId/duplicate",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getDuplicateMarketingTaskResponseMock(),
				{ status: 201 },
			)
		},
		options,
	)
}

export const getRunMarketingTaskNowMockHandler = (
	overrideResponse?:
		| RunMarketingTaskNowResponse
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<RunMarketingTaskNowResponse> | RunMarketingTaskNowResponse),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/marketing/tasks/:taskId/run",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getRunMarketingTaskNowResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getGetMarketingReportFieldsMockHandler = (
	overrideResponse?:
		| MarketingReportFieldsResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) =>
				| Promise<MarketingReportFieldsResponse>
				| MarketingReportFieldsResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/marketing/report-fields",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetMarketingReportFieldsResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}
export const getMarketingTasksMock = () => [
	getListMarketingTasksMockHandler(),
	getCreateMarketingTaskMockHandler(),
	getGetMarketingTaskMockHandler(),
	getUpdateMarketingTaskMockHandler(),
	getDeleteMarketingTaskMockHandler(),
	getToggleMarketingTaskMockHandler(),
	getDuplicateMarketingTaskMockHandler(),
	getRunMarketingTaskNowMockHandler(),
	getGetMarketingReportFieldsMockHandler(),
]
